import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteAnamnesisCatalog() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((questionId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/anamnesis-catalog/${questionId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
